import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceViewerModalComponent } from './resource-viewer-modal.component';
import { GlmResourceUploadModule } from '../glm-resource-upload/glm-resource-upload.module';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [ResourceViewerModalComponent],
  imports: [
    CommonModule,
    GlmResourceUploadModule,
    MatButtonModule
  ],
  exports: [ResourceViewerModalComponent]
})
export class ResourceViewerModalModule { }
